import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Chapters from "@/components/site/Chapters";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import Testimonials from "@/components/site/Testimonials";
import Clients from "@/components/site/Clients";
import PaymentSection from "@/components/site/PaymentSection";
import Inquiry from "@/components/site/Inquiry";
import Footer from "@/components/site/Footer";
import Chatbot from "@/components/site/Chatbot";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Chapters />
      <Marquee />
      <Services />
      <Stats />
      <Testimonials />
      <Clients />
      <PaymentSection />
      <Inquiry />
      <Footer />
      <Chatbot />
    </main>
  );
}
